module.exports = __webpack_public_path__ + "images/508bd40ff85d6ef5f48c1e6b2c978ed7.png";